<form class="form-container job-selection-dialog-content" [formGroup]="tsneForm">
    <cds-form-group layout="horizontal" controlWidth="shrink">
        <div class="number-input-row">
            <label class="number-input-label">Perplexity</label>
            <input
                class="number-input-no-arrow"
                type="number"
                [min]="1"
                [formControlName]="PERPLEXITY_FORM_KEY"
            />
        </div>
        <div class="number-input-row">
            <label class="number-input-label">Learning rate</label>
            <input
                class="number-input-no-arrow"
                type="number"
                [min]="0"
                [formControlName]="LEARNING_RATE_FORM_KEY"
            />
        </div>
        <div class="number-input-row">
            <label class="number-input-label">Number of iterations</label>
            <input
                class="number-input-no-arrow"
                type="number"
                step="any"
                [min]="250"
                [formControlName]="NUMBER_OF_ITERATIONS_FORM_KEY"
            />
        </div>
        <cds-checkbox-group controlWidth="shrink">
            <label>Random initialization</label>
            <cds-checkbox controlWidth="shrink">
                <label></label>
                <input type="checkbox" [formControlName]="RANDOM_INITIALIZATION_FORM_KEY" />
            </cds-checkbox>
        </cds-checkbox-group>
        <cds-checkbox-group controlWidth="shrink">
            <label>Exact gradient computation</label>
            <cds-checkbox controlWidth="shrink">
                <label></label>
                <input type="checkbox" [formControlName]="EXACT_GRADIENT_FORM_KEY" />
            </cds-checkbox>
        </cds-checkbox-group>
        <cds-select controlWidth="shrink">
            <label>Normalization</label>
            <select [formControlName]="NORMALIZATION_FORM_KEY">
                <option *ngFor="let normalization of ClusteringNormalizationValues">
                    {{ normalization }}
                </option>
            </select>
        </cds-select>
    </cds-form-group>
    <div class="validation-summary tsne-selection-form-footer" *ngIf="validationSummaryMessages.length">
        <div
            *ngFor="let msg of validationSummaryMessages"
            class="error-message validation-summary-line"
        >
            {{ msg }}
        </div>
    </div>
</form>
<div class="actions action-buttons">
    <cds-button size="sm" action="flat" (click)="cancel()">Cancel</cds-button>
    <cds-button size="sm" (click)="confirmParams()" [disabled]="!paramsValid">Next</cds-button>
</div>
